import { render, staticRenderFns } from "./FormaDataCreate.vue?vue&type=template&id=be542330&scoped=true&"
import script from "./FormaDataCreate.vue?vue&type=script&lang=js&"
export * from "./FormaDataCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be542330",
  null
  
)

export default component.exports